var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgApple = function SvgApple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43 0H5a5 5 0 0 0-5 5v38a5 5 0 0 0 5 5h38a5 5 0 0 0 5-5V5a5 5 0 0 0-5-5Z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.241 15.692c.908 0 2.046-.632 2.723-1.476.614-.764 1.061-1.831 1.061-2.898 0-.145-.013-.29-.038-.409-1.01.04-2.225.698-2.953 1.581-.575.672-1.1 1.726-1.1 2.807 0 .158.026.316.039.369.064.013.166.026.268.026Zm-3.196 15.944c1.24 0 1.79-.856 3.337-.856 1.572 0 1.917.83 3.298.83 1.355 0 2.263-1.291 3.12-2.556.958-1.45 1.354-2.873 1.38-2.939-.09-.026-2.685-1.12-2.685-4.19 0-2.662 2.046-3.86 2.16-3.953-1.354-2.003-3.413-2.056-3.975-2.056-1.521 0-2.761.949-3.541.949-.844 0-1.956-.896-3.273-.896-2.506 0-5.05 2.135-5.05 6.167 0 2.503.946 5.152 2.11 6.865.997 1.45 1.866 2.635 3.12 2.635Z",
    fill: "#fff"
  })));
};

export default SvgApple;